import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=06843a98&scoped=true&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06843a98",
  null
  
)

export default component.exports